import Http from "./base-http";

class TaskPosition extends Http {
  addTaskPosition(variables) {
    return this.create(variables);
  }
  deleteTaskPos(id) {
    return this.destroy(id);
  }
}
const taskPosition = new TaskPosition({
  modelUrlPrefix : "TaskPosition"
});
export default taskPosition;